export const environment = {
  name: 'staging',
  production: false,
  protocol: 'https://',
  baseAddress: 'api.staging.monek.com',
  odinBaseAddress: 'api.staging.monek.com/odin',
  clientRoot: 'https://staging-portal.monek.com/',
  apiRoot: 'api.staging.monek.com/odin/',
  releaseVersion: 'SHA-888685ad8fda927b4a9639010fe655a8af19380b',

  // cognito
  userPoolId: 'eu-west-2_FBa9FdzbI',
  appClientId: '49icjbbdjfum6lm89htiiec5ql',
  hostedLoginUrl: 'https://staging-authorise.monek.com',
  authCallbackUrl:
    'https://staging-portal.monek.com/authentication/auth-callback',

  congitoResource: 'https://staging-portal.monek.com/dashboard',
  cognitoAudience: 'https://api.staging.monek.com/odin/transactions',

  //xero
  xeroProtocol: 'https://',
  xeroBaseAddress: 'api.staging.monek.com/lofn-xero',

  //notifications
  notificationWebSocketUrl: 'wss://ws-staging.monek.com/notifications-ws',

  // CloudWatch RUM app monitor Odin-Merchant-Portal (Odin-Telemetry-Account stack).
  rum: {
    appMonitorId: '0009680f-2c32-419e-b061-ff44dc0a3590',
    region: 'eu-west-2',
    // The app monitor's resource-based policy allows unsigned PutRumEvents for this alias.
    alias: 'staging',
    applicationVersion: 'SHA-888685ad8fda927b4a9639010fe655a8af19380b',
    sessionSampleRate: 0.5,
  },

  // Fraction of requests sent with the sampled flag (ADR §5: dev/staging 1.0, prod 0.1). Server sampling is parent-based.
  trace: {
    sampleRate: 1,
  },

  featureToggles: {
    'trace-propagation': true,
    'rum-telemetry': true,
    fuzzySearch: true,
    'txn-recharge': true,
    'txn-complete': true,
    'pci-widget': false,
    'dashboard-metrics': true,
    'user-mfa-management': true,
    'pebl-qr': true,
    'extended-transactions': true,
    'mid-visibility': true,
    forumpay: true,
    'all-access-profile': true,
    
    // TODO: Cognito Hosted UI
    'new-profile-login': false,
    'new-token-refresh': false,
    'mfa-configuration': true,
    'new-transaction-experience': true,
  },

  brandings: [
    {
      name: 'MONEK BRANDING',
      logoUrl: '/assets/images/logo.png',
      brandName: 'MONEK',
      hasTextLogo: true,
      textLogoClass: 'monek-font',
      fixedTheme: false, // can change theming?
      themeClass: '', // theme class if fixedTheme is true
      logoWidth: 'auto',
      logoHeight: '20px',
      availableThemes: [
        { value: 'light', view: 'Light Mode' },
        { value: 'dark', view: 'Dark Mode' },
      ],
    },
  ],
  selectedBrandName: 'MONEK BRANDING',
};
